import React, { useEffect, useState } from "react";

/** members 세션과 무관하게 심볼만 로드 (관리자 쿠키와 /SetPage/user 불일치 방지). */
export default function SymbolSearchPopup({ isOpen, onAdd, onClose, anchorPosition }) {
    const [totalsymbolList, setTotalSymbolList] = useState([]);

    useEffect(() => {
      fetch('/bingx_symbols')
        .then((res) => res.json())
        .then((data) => {
          setTotalSymbolList(data.symbols || []);
        })
        .catch((err) => console.error('빙엑스 심볼 불러오기 실패:', err));
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
    const filteredList = totalsymbolList.filter((s) =>
      s.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isOpen) return null;

    const isInline = Boolean(anchorPosition);
    const backdropClass = isInline ? 'popup-inline' : 'popup-backdrop';
    const backdropStyle = isInline
      ? {
          '--popup-top': `${anchorPosition.top}px`,
          '--popup-left': `${anchorPosition.left}px`,
        }
      : undefined;

    return (
          <div
            className={backdropClass}
            style={backdropStyle}
            onClick={() => {
              if (!isInline) {
                onClose();
              }
            }}
          >
            <div className="popup" onClick={(e) => e.stopPropagation()}>
              <h3>심볼 검색/선택</h3>
              <input
                type="text"
                placeholder="심볼을 입력하세요"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              <ul className="suggestion-list">
                {filteredList.map((symbol, idx) => (
                  <li
                    key={idx}
                    className="suggestion-item"
                    onClick={() => {
                      onAdd(symbol);
                      setSearchTerm("");
                    }}
                  >
                    {symbol}
                  </li>
                ))}
              </ul>
              <button onClick={onClose} className="close-button">닫기</button>
            </div>
          </div>
       );
};
  